module.exports = __webpack_public_path__ + "img/checked.cb128abf.png";